import React from 'react'
import BannerInfoScroll from '../pages/Homepage/BannerInfoScroll'
import Button from './Button'

const Footer = () => {
  return (
    <div className=''>
    <div>
    <div className='flex justify-end w-full'>
      <p className='text-[56px] font-bold tracking-wide text-neutral-800 uppercase'>Mary</p>
    </div>
    <BannerInfoScroll/>
    <div className='flex flex-row justify-between '>
      <div className='w-20 min-h-full bg-neutral-900'></div>
      <div className='flex flex-col md:flex-row justify-between px-10 md:px-20 w-full '>
      <div className="uppercase text-[2rem] font-[600] md:py-16 pt-10">
          <div className="flex flex-row items-center gap-5">
            <p className="leading-[0]">Let's</p>
            <div>
              <Button />
            </div>
          </div>
          <div>grow together</div>
        </div>
      <div className='grid grid-cols-1 gap-20 py-16'>

        <div className='flex flex-col gap-2'>
          <a className='uppercase' href='https://www.linkedin.com/in/mary-ojo/' target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a className='uppercase' href='https://www.github.com/maryojo/' target="_blank" rel="noopener noreferrer">Github</a>
          {/* <a className='uppercase' href='https://instagram.com/maye_tech' target="_blank" rel="noopener noreferrer">Instagram</a> */}
          <a className='uppercase' href='https://www.youtube.com/@maye_tech' target="_blank" rel="noopener noreferrer">Youtube</a>
        </div>
      </div>
      </div>
      <div className='w-20 min-h-full bg-neutral-900'></div>
    </div>
    </div>
    <hr className="border-[1px] border-neutral-900" />
    <div className='flex flex-col md:flex-row gap-5 md:gap-0 justify-between text-sm text-neutral-500 py-5 px-5 md:px-10'>
      <div>Designed and built by me with React, TailwindCSS & Framer Motion</div>
      <div className=''>
        &copy; Mary Ojo (2024)
      </div>
    </div>
    </div>
  )
}

export default Footer